import { createFileRoute } from '@tanstack/react-router'
import MarketingModelosEmailsEditorPage from '@/pages/dashboard/marketing-modelos-emails-editor-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/novo',
)({
  component: function MarketingModelosEmailsNovoRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingModelosEmailsEditorPage mode="create" />
      </RequireModule>
    )
  },
})
